// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/.pnpm/css-loader@3.6.0_webpack@4.47.0_supports-color@6.1.0_/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.international[data-v-ae4e648c] {\n  padding-left: 28px;\n  margin-right: -1em;\n  width: 53px;\n}\n.international-icon[data-v-ae4e648c] {\n  margin-right: 10px;\n  margin-left: 3px;\n  width: 24px;\n}\n.international-icon[data-v-ae4e648c]:hover {\n  cursor: pointer;\n}\n", ""]);
// Exports
module.exports = exports;
